import { HasId, ID } from "src/libs/interfaces/layouts"
import { SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"

export const HIDE_OPACITY = ".25"
export const NOT_HIDE_OPACITY = "1" 

export const hideOver = ( sectionId: ID = "", itemId: ID = "",  ) => {
    setTimeout(() => {
        const selectedElementsType  = useLandingStore.getState().selectedElementsType
        const selectedSectionId     = useLandingStore.getState().selectedSectionId
        const selectedElements      = useLandingStore.getState().selectedElements
        const isDeselect            = !selectedElements.length
        const items  = document.querySelectorAll(`.landing-section-container.landing-gap`) 
        items.forEach((item: any) => {    
            let fid, is: boolean
            const isMe = item.getAttribute("id") === sectionId
            item.style.opacity = !selectedElements.length ? NOT_HIDE_OPACITY : isMe ? NOT_HIDE_OPACITY : HIDE_OPACITY
            const title1 = item?.querySelector(`.landing-section-title-container`) as HTMLElement
            if(!!title1) {
                title1.style.opacity = isMe ? HIDE_OPACITY : NOT_HIDE_OPACITY
            }

            const meats  = item?.querySelectorAll(`.landing-data-components-container > div`)
            const floats = item?.querySelectorAll(`.landing-float-position-container > div`)
            const selIds: ID[] = selectedElements.map( (s: HasId) => s.id)

            switch( selectedElementsType) {
                case SELECT_TYPE.FLOAT:
                    floats?.forEach((float: any) => {
                        fid = float.querySelector(`[data-content-id]`).getAttribute("data-content-id")
                        is = selIds.includes( fid )                   
                        //if( is ) console.log( is, fid, selIds )
                        
                        float.style.opacity =  !selectedElements.length ? NOT_HIDE_OPACITY : isMe 
                            ? 
                            is ? NOT_HIDE_OPACITY : HIDE_OPACITY
                            : 
                            HIDE_OPACITY
                    })
                    meats?.forEach((meat: any) => {
                        meat.style.opacity = isMe 
                            ?
                            HIDE_OPACITY 
                            : 
                            NOT_HIDE_OPACITY 
                    })
                    break
                case SELECT_TYPE.CONTENT:
                default:    
                    meats?.forEach((meat: any) => {
                        fid = meat.querySelector(`[data-content-id]`).getAttribute("data-content-id")
                        is = selIds.includes( fid )              
                        //if( is ) console.log( is, fid, selIds )

                        meat.style.opacity =  !selectedElements.length ? NOT_HIDE_OPACITY : isMe 
                            ? 
                            is ? NOT_HIDE_OPACITY : HIDE_OPACITY
                            : 
                            HIDE_OPACITY
                    })

                    floats?.forEach((float: any) => {
                        float.style.opacity = isMe 
                            ?
                            HIDE_OPACITY 
                            : 
                            NOT_HIDE_OPACITY 
                    }) 
                    break
            }
        })
    }, 30);
} 